import { Component, Input, OnInit } from '@angular/core';
import { FormField } from '@shared/components/form/models/beans/form-field.abstract';
import { filter, map, take } from 'rxjs/operators';
import { AbstractControl } from '@angular/forms';
import { IndexedDBService } from '@core/services/indexeddb.service';

@Component({
    selector: 'filefield',
    templateUrl: './filefield.component.html',
    styleUrls: ['./filefield.component.scss'],
})
export class FilefieldComponent extends FormField implements OnInit {
    @Input() accept: string;
    @Input() isFormArray: boolean;

    fileName: string;

    constructor(private indexDb: IndexedDBService) {
        super();
    }

    ngOnInit(): void {
        this.setFile();
    }

    fileChangeEvent(event: Event) {
        const input = event.target as HTMLInputElement;

        if (!input.files || !input.files[0]) {
            return;
        }

        const file: File = input.files[0];

        this.indexDb
            .add(file)
            .pipe(take(1))
            .subscribe((allegato) => {
                this.fileName = file.name;

                if (!this.isFormArray) {
                    this.field.setValue(allegato.id);
                } else {
                    this.fieldControl.setValue(allegato.id);
                }
            });
    }

    deleteFile(): void {
        if (!this.isFormArray) {
            this.indexDb.deleteByKey(this.field.value).subscribe(() => {
                this.field.reset();
            });
        } else {
            this.indexDb.deleteByKey(this.fieldControl.value).subscribe(() => {
                this.fieldControl.reset();
            });
        }
    }

    openFile(): void {
        if (!this.isFormArray) {
            this.indexDb
                .getByID(this.field.value)
                .pipe(
                    filter((res) => !!res),
                    map((res) => res.file)
                )
                .subscribe((file) => {
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL, '_blank');
                });
        } else {
            this.indexDb
                .getByID(this.fieldControl.value)
                .pipe(
                    filter((res) => !!res),
                    map((res) => res.file)
                )
                .subscribe((file) => {
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL, '_blank');
                });
        }
    }

    // private get base64File$(): Observable<string> {
    //   return new Observable<string>(subscriber => {
    //     this.indexDb.getByID(this.field.value).pipe(
    //       map(res => res.file)
    //     ).subscribe(file => {
    //
    //       const reader = new FileReader();
    //       reader.readAsDataURL(file);
    //
    //       reader.onload = () => {
    //         subscriber.next(reader.result as string);
    //         subscriber.complete();
    //       }
    //
    //     })
    //   })
    // }

    private setFile(fileId?: string): void {
        if (!this.isFormArray) {
            fileId = fileId ? fileId : this.field.value;
            if (!fileId) return;

            this.indexDb
                .getByID(fileId)
                .pipe(
                    filter((res) => !!res),
                    map((res) => res.file.name)
                )
                .subscribe((fileName) => {
                    this.fileName = fileName;
                });
        } else {
            fileId = fileId ? fileId : this.fieldControl.value;
            if (!fileId) return;

            this.indexDb
                .getByID(fileId)
                .pipe(
                    filter((res) => !!res),
                    map((res) => res.file.name)
                )
                .subscribe((fileName) => {
                    this.fileName = fileName;
                });
        }
    }

    private get field(): AbstractControl {
        return this.form.get(this.fieldName);
    }
}
